import React from "react";
import { Select } from "antd";
import Widget from "../../../../../components/Widget";
import style from "./LeftWidget.module.scss";
import { TeacherCourse } from "../../../../../service/service";
import _ from "underscore";

const { Option } = Select;

interface LeftWidgetProps {
    list: TeacherCourse[];
    lmsCourseNo: string;
    onSelect: (value: string) => void;
}

export default function LeftWidget({
    list,
    lmsCourseNo,
    onSelect
}: LeftWidgetProps) {
    return (
        <div className={style.root}>
            <Widget title="课程列表" bodyPadding>
                <div className={style.item}>
                    <label className={style.label}>课程：</label>

                    <Select
                        defaultValue=""
                        style={{ width: 200 }}
                        onSelect={onSelect}>
                        <Option value="">全部</Option>
                        {_.map(list!, item => (
                            <Option
                                value={item.lmsCourseNo}
                                key={item.lmsCourseNo}>
                                {item.courseName}
                            </Option>
                        ))}
                    </Select>
                </div>

                <div className={style.item}>
                    {lmsCourseNo && (
                        <label className={style.label}>编号：</label>
                    )}
                    {
                        _.find(list, item => item.lmsCourseNo === lmsCourseNo)
                            ?.courseNo
                    }
                </div>

                <div className={style.item}>
                    {lmsCourseNo && (
                        <label className={style.label}>序号：</label>
                    )}
                    {
                        _.find(list, item => item.lmsCourseNo === lmsCourseNo)
                            ?.courseSeq
                    }
                </div>
            </Widget>
        </div>
    );
}
